import { Box } from '@mui/material';
import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
};
/**
 * This component is specifically for making text accessible to screen readers while keeping it visually hidden from the page.
 */
export const AccessibleHiddenText = ({ children }: Props) => {
  return (
    <Box
      component="span"
      sx={{
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: '1px',
        overflow: 'hidden',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px',
      }}
    >
      {children}
    </Box>
  );
};
